import { Provider } from 'react-redux';
import store from './store/index';

export function ReduxProvider({ children }) {
    return <Provider store={store}>{children}</Provider>;
}
